import type React from 'react'

import { clsJoin } from '@/utils'
import css from './styles.module.css'

interface Props extends React.PropsWithChildren {
  title: string
  description?: string
  iconLeft?: React.ReactNode
  titleCenter?: boolean
  withHover?: boolean
}

export const SettingCardRow: React.FC<Props> = ({
  title,
  description,
  iconLeft,
  titleCenter,
  withHover,
  children,
}) => (
  <div className={css.setting_card_row}>
    <div
      className={clsJoin(css.setting_card_row_wrap, titleCenter && css.center)}
    >
      <div
        className={clsJoin(css.setting_card_row_title, withHover && css.hover)}
      >
        {iconLeft} {title}
      </div>
      {description && (
        <div
          className={clsJoin(
            css.setting_card_row_description,
            !!iconLeft && css.left_margin
          )}
        >
          {description}
        </div>
      )}
    </div>

    <div className={css.setting_card_row_children}>{children}</div>
  </div>
)
